import { render, staticRenderFns } from "./VideoRoom.vue?vue&type=template&id=f3cab196"
import script from "./VideoRoom.vue?vue&type=script&lang=js"
export * from "./VideoRoom.vue?vue&type=script&lang=js"
import style0 from "./VideoRoom.vue?vue&type=style&index=0&id=f3cab196&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports